import { PermissionActivity } from './PermissionsList.types';
import { IPermissionDetail } from '../../../services/rolesAndPermissions/rolesAndPermissions.types';

export const getActivityLabel = (activity: PermissionActivity): string => {
  switch (activity) {
    case PermissionActivity.active:
      return 'Aktywne';
    case PermissionActivity.inActive:
      return 'Nieaktywne';
    case PermissionActivity.all:
      return 'Wszystkie';
    default:
      return '???';
  }
};

export const comparePermissionsByName = (a: IPermissionDetail, b: IPermissionDetail) =>
  (a.name ?? '').localeCompare(b.name ?? '');
